export default Object.freeze({
  Andador: 4,
  SillaRuedas: 5,
  SillaMotorizada: 6
});
